import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Typography, notification } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import SelectVendedoresItem from "../../../../Components/SelectVendedoresItem";

const { Text } = Typography;

const ModalReasignarLead = ({
  visible,
  lead,
  onCancel,
  onExito,
  headersToken,
  empresaId,
  rapido, // Desde el tablero: sin escribir "Reasignar" para confirmar
}) => {
  const [nuevoUsuarioId, setNuevoUsuarioId] = useState(null);
  const [palabraConfirmacion, setPalabraConfirmacion] = useState("");
  const [loading, setLoading] = useState(false);

  // Limpiar estado al abrir/cerrar
  useEffect(() => {
    if (visible) {
      setNuevoUsuarioId(null);
      setPalabraConfirmacion("");
    }
  }, [visible]);

  const puedeConfirmar =
    !!nuevoUsuarioId && (rapido || palabraConfirmacion === "Reasignar");

  const handleReasignar = () => {
    if (!puedeConfirmar) return;

    setLoading(true);
    axios
      .post(
        "leads/reasignarLead",
        { leadId: lead._id, nuevoUsuarioId },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({ message: "Lead reasignado correctamente." });
          if (onExito) onExito();
        } else {
          notification.error({
            message: res.data.message || "Error al reasignar el lead.",
          });
        }
      })
      .catch(() => {
        notification.error({ message: "Error de red al reasignar el lead." });
      })
      .finally(() => setLoading(false));
  };

  if (!lead) return null;

  const responsableActual = lead.usuarioId?.nombre ?? "—";

  return (
    <Modal
      title={rapido ? "Asignar Lead" : "Reasignar Lead"}
      visible={visible}
      okText={rapido ? "Asignar" : "Reasignar"}
      okButtonProps={{
        disabled: !puedeConfirmar,
        danger: !rapido,
        loading,
      }}
      cancelText="Cancelar"
      onOk={handleReasignar}
      onCancel={onCancel}
      destroyOnClose
    >
      <p>
        <Text type="secondary">Lead: </Text>
        <Text strong>{lead.descripcion}</Text>
      </p>
      <p>
        <Text type="secondary">Responsable actual: </Text>
        <Text strong>{responsableActual}</Text>
      </p>

      <Form layout="vertical">
        <Form.Item label="Nuevo responsable" required>
          <SelectVendedoresItem
            headersToken={headersToken}
            empresaId={empresaId}
            embudoId={lead.embudoId?._id ?? lead.embudoId}
            placeholder="Selecciona un empleado..."
            onChange={(id) => setNuevoUsuarioId(id ?? null)}
            allowClear
          />
        </Form.Item>

        {!rapido && (
          <Form.Item
            label={
              <span>
                Escribe <Text code>Reasignar</Text> para confirmar
              </span>
            }
          >
            <Input
              placeholder='Escribe "Reasignar"'
              value={palabraConfirmacion}
              onChange={(e) => setPalabraConfirmacion(e.target.value)}
              onPressEnter={() => puedeConfirmar && handleReasignar()}
            />
          </Form.Item>
        )}
      </Form>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalReasignarLead);
